import './styles/public.scss';
import {renderBanner, initScript, eyezonPutInCart} from './js/floating';

export default {renderBanner, initScript, eyezonPutInCart};

window.onload = () => {
	(() => {
	})();
	if (window.hasOwnProperty('eyezonWidget')) {
		window.eyezonRenderBanner = renderBanner;
		window.eyezonInitScript   = initScript;
		window.eyezonPutInCart    = eyezonPutInCart;
		window.eyezonWidget();
	}
};
